/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react"
import {
  Box,
  Button,
  Checkbox,
  Link,
  TextField,
  Typography,
} from "@mui/material"
import { useSearchParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
  ContentContainer,
  ConfirmContainer,
  PhoneInput,
  LogoContainer,
} from "./components/styles"
import { formatPhoneNumberInput } from "../../utils/formatters"
import { isPhoneNumber } from "../../utils/contacts"
import UIIcon from "../../components/UIIcon"
import { useRegistration } from "../../api/hooks/useRegistration"
import LoadingOverlay from "../../components/LoadingOverlay"
import { setToken } from "../../store/slices/auth"
import { setRegistrationPhoneNumber } from "../../store/slices/registration"

// @ts-ignore
// eslint-disable-next-line no-var, @typescript-eslint/no-unused-vars
window.createTokenUrl = (token) =>
  `http://localhost:3000/top-up-mbank-account/registration?token=${token}`

const Registration = () => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [isAgreementChecked, setIsAgreementChecked] = useState(false)
  const [isOfferChecked, setIsOfferChecked] = useState(false)
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const { mutate: register, isPending } = useRegistration()

  useEffect(() => {
    const token = searchParams.get("token")
    if (token) {
      dispatch(setToken(token))
    }
  }, [searchParams, dispatch])

  const handleClickRegistration = () => {
    if (isPhoneNumber(phoneNumber)) {
      dispatch(setRegistrationPhoneNumber(phoneNumber))
      register(phoneNumber)
    }
  }

  const handleAgreementCheckboxChange = () => {
    setIsAgreementChecked(!isAgreementChecked)
  }

  const handleOfferCheckboxChange = () => {
    setIsOfferChecked(!isOfferChecked)
  }

  const handlePhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const inputValue = event.target.value
    const formattedPhoneNumber = formatPhoneNumberInput(inputValue)
    setPhoneNumber(formattedPhoneNumber)
  }

  const isPhoneValid = isPhoneNumber(phoneNumber)

  if (isPending) {
    return (
      <LoadingOverlay
        disableOpacity
        title="Проверка данных"
        text="Пожалуйста, подождите"
      />
    )
  }

  return (
    <Box sx={ContentContainer}>
      <Box sx={LogoContainer}>
        <Typography variant="h3" sx={{ mb: 1, mt: 3 }}>
          Для продолжения <br /> пополнения вам нужно <br /> открыть "Единый
          кошелек"
        </Typography>
      </Box>

      <TextField
        label="Мобильный телефон"
        variant="outlined"
        type="tel"
        sx={PhoneInput}
        onChange={handlePhoneNumberChange}
        value={phoneNumber}
        InputProps={{
          endAdornment: <UIIcon iconName="frfIcon" size={35} />,
        }}
      />
      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box
          sx={ConfirmContainer}
          onClick={(e) => {
            if (!(e.target as HTMLElement).closest("a")) {
              setIsAgreementChecked(!isAgreementChecked)
            }
          }}
        >
          <Checkbox
            checked={isAgreementChecked}
            onChange={handleAgreementCheckboxChange}
            sx={{ padding: "0 8px 0 0" }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          />
          <Typography variant="body2" color="text.secondary">
            Нажимая на кнопку «Открыть кошелек» я даю свое{" "}
            <Link
              href="https://xn--80aaanetpw3ba4m.xn--p1ai/wp-content/uploads/9_Soglasie_na_obrabotku_PD_MBank.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              согласие на обработку персональных данных
            </Link>
          </Typography>
        </Box>
        <Box
          sx={ConfirmContainer}
          onClick={(e) => {
            if (!(e.target as HTMLElement).closest("a")) {
              setIsOfferChecked(!isOfferChecked)
            }
          }}
        >
          <Checkbox
            checked={isOfferChecked}
            onChange={handleOfferCheckboxChange}
            sx={{ padding: "0 8px 0 0" }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          />
          <Typography variant="body2" color="text.secondary">
            Нажимая на кнопку «Открыть кошелек» я даю свое{" "}
            <Link
              href="https://xn--80aaanetpw3ba4m.xn--p1ai/wp-content/uploads/Oferta_platezhnogo_servisa_MBANK.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              согласие с офертой Платежного сервиса «Единый кошелек - Мбанк»
            </Link>
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={handleClickRegistration}
          disabled={!isAgreementChecked || !isOfferChecked || !isPhoneValid}
          sx={{
            width: "100%",
            borderRadius: 2,
            py: 1.5,
          }}
        >
          Открыть кошелек
        </Button>

      </Box>
    </Box>
  )
}

export default Registration
